import React, { useEffect, useContext, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { SatCoreRegister } from '../SatCoreRegistry';
import ReactHtmlParser from 'react-html-parser';
import { Loader } from 'semantic-ui-react';

import Auth from '../managers/AuthManager';

import '../css/PrivacyPolicy.less';

const PrivacyPolicy = observer(() => {

  const { contextHelpManager } = useContext(MobXProviderContext);

  const [privacyPolicy, setPrivacyPolicy] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      const publisherSatelliteCode = Auth.publisherSatelliteCode;
      const contextHelpId = `${publisherSatelliteCode}_PRIVACY_POLICY`;
      if (!contextHelpManager.contextHelpMap.has(contextHelpId)) {
        await contextHelpManager.fetchContextHelp(contextHelpId);
      }
      const privacyPolicy = contextHelpManager.contextHelpMap.get(contextHelpId);
      setPrivacyPolicy(privacyPolicy);
      setIsLoading(false);
    };
    fetchPrivacyPolicy();
  }, []);

  useEffect(() => {
    if (privacyPolicy === null) return;
    
    if (!privacyPolicy) {
      window.history.back();
    }
  }, [privacyPolicy]);

  if (isLoading) {
    return (
      <div className='centered-loader'>
        <Loader active inline='centered' />
      </div>
    );
  }

  return privacyPolicy ? (
    <div className='privacy-policy'>
      <div className='privacy-policy-title'>Privacy Policy</div>
      <div className='privacy-policy-body'>
        {ReactHtmlParser(privacyPolicy)}
      </div>
    </div>
  ) : (
    <div className='privacy-policy'>
      No Privacy Policy found
    </div>
  );
});

export default PrivacyPolicy;
SatCoreRegister('PrivacyPolicy', PrivacyPolicy);